import { TextField } from "@mui/material"
import { TestData } from "graphql/types"
import { useEffect } from "react"

type TakeDurationBoxProps = {
  data: TestData
  setData: (data: TestData) => void
}

export const TakeDurationBox = (props: TakeDurationBoxProps) => {
  const { data, setData } = props

  useEffect(() => {
    const now = new Date()
    const currentDateTime = now.toISOString().slice(0, 16)
    if (!data.beginTime) {
      setData({ ...data, beginTime: currentDateTime })
    }
    if (!data.endTime) {
      setData({ ...data, endTime: currentDateTime })
    }
  }, [data, setData])

  return (
    <>
      <TextField
        sx={{ mt: 1 }}
        size="small"
        value={data.beginTime}
        variant="outlined"
        type="datetime-local"
        fullWidth
        label="Beginn"
        slotProps={{ inputLabel: { shrink: true } }}
        onChange={(e) => setData({ ...data, beginTime: e.target.value })}
      />
      <TextField
        sx={{ mt: 1 }}
        size="small"
        value={data.endTime}
        variant="outlined"
        type="datetime-local"
        fullWidth
        label="Ende"
        slotProps={{ inputLabel: { shrink: true } }}
        onChange={(e) => setData({ ...data, endTime: e.target.value })}
      />
    </>
  )
}
